// Module
var code = "<el-alert v-if=\"warningEndPending || warningEndLicenses\" style=\"margin-bottom:20px\" :title=\"titleWarningMessageLicenses\" type=\"error\" effect=\"dark\" @click.self.native=\"redirectOnLicensesPage()\"> </el-alert> ";
// Exports
module.exports = code;